import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { NomenclatureTypeEnum } from '@zaoblako/shared/modules/catalog/enums/nomenclature-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link NomenclatureTypeEnum} enumeration values */
export const NomenclatureTypeEnumI18n: EnumI18nInterface<NomenclatureTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [NomenclatureTypeEnum.PRODUCT]: 'Товар',
    [NomenclatureTypeEnum.SERVICE]: 'Услуга',
  },
  [I18nLocalesEnum.EN_US]: {
    [NomenclatureTypeEnum.PRODUCT]: 'Product',
    [NomenclatureTypeEnum.SERVICE]: 'Service',
  },
};
